/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-arrow-left': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" _fill="#fff" d="M7.273 11.687a1 1 0 101.454-1.374l-1.454 1.374zM3 6l-.707-.707a.998.998 0 00.014 1.427L3 6zm5.707-4.293A1 1 0 007.293.293l1.414 1.414zm.02 8.606a141.227 141.227 0 00-3.257-3.3c-.505-.498-.949-.931-1.266-1.24l-.374-.362-.101-.097-.026-.026-.007-.006-.002-.002L3 6l-.693.72v.001l.002.002.006.006.026.024.099.096.37.359c.315.306.755.735 1.256 1.229 1.004.99 2.243 2.23 3.207 3.25l1.454-1.374zm-5.02-3.606l5-5L7.293.293l-5 5 1.414 1.414z"/>'
  }
})
